/**
 * Whenever a DOM id is needed, add it here and use the enum instead of hardcoded string.
 *
 * E.g. Useful when working with React Portals.
 */
export enum ComponentIDS {
    HEADER = 'HeaderID',
}
